import { render } from "./applicantCheckForCampaign.vue?vue&type=template&id=4768d288&scoped=true&ts=true"
import script from "./applicantCheckForCampaign.vue?vue&type=script&lang=ts"
export * from "./applicantCheckForCampaign.vue?vue&type=script&lang=ts"

import "./applicantCheckForCampaign.vue?vue&type=style&index=0&id=4768d288&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4768d288"]])

export default __exports__